<template>
  <div
    class="form-bg d-flex justify-content-center align-items-center"
  >
    <div class="form-wrapper mt-5">
      <h2 class="text-center mb-4">Visa Enquiry Form</h2>
      <form @submit.prevent="submitForm">
        <div class="mb-3">
          <label for="name" class="form-label">Full Name</label>
          <input
            type="text"
            class="form-control"
            id="name"
            v-model="form.name"
            required
          />
        </div>

        <div class="mb-3">
          <label for="email" class="form-label">Email Address</label>
          <input
            type="email"
            class="form-control"
            id="email"
            v-model="form.email"
            required
          />
        </div>

        <div class="mb-3">
          <label for="phone" class="form-label">Phone Number</label>
          <input
            type="tel"
            class="form-control"
            id="phone"
            v-model="form.phone"
            required
          />
        </div>

        <div class="mb-3">
          <label for="message" class="form-label">Your Message</label>
          <textarea
            class="form-control"
            id="message"
            rows="4"
            v-model="form.message"
            required
          ></textarea>
        </div>

        <button type="submit" class="btn btn-primary w-100" :disabled="loading">
          {{ loading ? "Submitting..." : "Submit" }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { db, auth } from "@/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import Swal from "sweetalert2";

export default {
  name: "TravelConsultation",
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        message: "",
      },
      loading: false,
      user: null,
    };
  },
  created() {
    onAuthStateChanged(auth, (user) => {
      this.user = user; // set user when logged in
    });
  },
  methods: {
    async submitForm() {
      if (!this.user) {
        await Swal.fire({
          icon: "info",
          title: "Login Required",
          text: "You are not logged in. Please login to submit your enquiry.",
          confirmButtonText: "Go to Login",
          showCancelButton: true,
          cancelButtonText: "Cancel",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#aaa",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.push("/login");
          }
        });
        return;
      }

      if (!this.form.name || !this.form.email || !this.form.phone || !this.form.message) {
        Swal.fire("Missing Info", "Please fill all fields before submitting.", "warning");
        return;
      }

      this.loading = true;
      try {
        await addDoc(collection(db, "consultationRequests"), {
          ...this.form,
          userId: this.user.uid,
          createdAt: serverTimestamp(),
        });

        Swal.fire("Success!", "Consultation request submitted successfully!", "success");
        this.form = { name: "", email: "", phone: "", message: "" };
      } catch (error) {
        console.error("Error saving consultation:", error);
        Swal.fire("Error", "Something went wrong. Please try again later.", "error");
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>
.form-bg {
  background: url("@/assets/images/visa_page.jpg") no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
  min-height: 100vh;
  padding: 2rem;
}

.form-wrapper {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 2rem;
  border-radius: 20px;
  width: 80%;
  max-width: 700px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
  .form-wrapper {
    width: 95%;
    padding: 1.5rem;
  }
}
</style>
